export function itemBlockReason(item, sessionReady = true) {
  if (!sessionReady) return 'Open the counter before adding items';
  if (item.can_sell === false && !['Out of stock','Recipe ingredients are unavailable or reserved'].includes(item.stock_issue)) return item.stock_issue || 'Unavailable';
  return null;
}

export function requestedQuantity(item) {
  return item.uom === 'KG' ? Number(item.grams || 0) / 1000 : Number(item.qty || 0);
}

export function exceedsAvailable(item, quantity) {
  // Inventory shortages are reconciled separately; never block cashier quantities.
  return false;
}
export function availabilityLabel(item) {
  if (item.inventory_mode === 'made_to_order' && item.usage_method === 'closing') return 'Made to order · usage reported at MH closure';
  return `${item.low_stock?'Low stock · ':''}${item.inventory_mode==='made_to_order'?'Recipe capacity':'Stock'}: ${Number(item.stock).toLocaleString(undefined,{maximumFractionDigits:3})} ${item.uom}`;
}
